import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import {PredefinedNoteDataModel} from '../../../../models/notes/predefined-note-data.model';

@Component({
  selector: 'app-note-builder-create',
  templateUrl: './note-builder-create.component.html',
  styleUrls: ['./note-builder-create.component.css']
})
export class NoteBuilderCreateComponent implements OnInit {

  template: string = '';
  description: string = '';
  isEdit: boolean = false;
  predefinedNote: PredefinedNoteDataModel;

  constructor(
    private dialogRef: MatDialogRef<NoteBuilderCreateComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) { }

  ngOnInit() {
    if (this.data && this.data.predefinedNote) {
      this.isEdit = true;
      this.predefinedNote = this.data.predefinedNote;
    } else {
      this.predefinedNote = new PredefinedNoteDataModel();
      this.predefinedNote.isSeparator = false;
    }
  }

  save() {
    this.dialogRef.close(this.predefinedNote);
  }

  cancel() {
    this.dialogRef.close(null);
  }

}
